import { useTypedSelector } from "../hooks";
import { GroupAccountInfoPayload } from "../slices/groupAccountInfoSlice";

export const useNullableGroupAccountInfo = (): GroupAccountInfoPayload => {
  const state = useTypedSelector(({ _groupAccountInfo }) => _groupAccountInfo);
  return state;
};
